import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'SERVICES/ALL';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetServices(client) {
  try {
    const response = yield client.post('/service/all');
    yield put(actions.loadSuccess(response.result.services));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
